module.exports = __webpack_public_path__ + "static/img/束腰连体衣.0f756743.jpg";